'use strict';

angular.module('ClinicApp').directive('banners', function(CurrentUser, OCUtil, OCBannerUtil) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_banners.html',
    link: function($scope) {
      return CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function() {
        return OCUtil.getModelFromURL('clinic').then(function(clinic) {
          if (OCBannerUtil.shouldShowPromoNPRsRemainingBanner(clinic)) {
            $scope.showPromoNPRsRemainingBanner = true;
          }
        });
      });
    },
  };
});
